module.exports = __webpack_public_path__ + "20250721160708/img/category.e9c2f73b.png";